module.exports = __webpack_public_path__ + "static/banner-tablet-2a7ef16d656d03dfce091105d38555d4.png";